import { render, staticRenderFns } from "./edit-widget-settings-color-line.vue?vue&type=template&id=1b32e608&scoped=true&"
import script from "./edit-widget-settings-color-line.vue?vue&type=script&lang=js&"
export * from "./edit-widget-settings-color-line.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b32e608",
  null
  
)

export default component.exports